import React from 'react';

import { AUTOCOMPLETE_ADDRESS, AUTOCOMPLETE_POST_CODE, COUNTRY, DATE, DROP_BOX, PHONE_COUNTRY, SBP_DROP_BOX, TEXT } from 'constants/FieldType';

import { inputPropType } from 'helpers/customPropTypes';
import { toUpperCase } from 'helpers/utils';

import PromoInputBase from './PromoInputBase';
import { notValidateUpdateValue } from './utils';

const PromoInputText = (props) => {
    const field = props.field;
    if (field.value === null) {
        field.value = '';
    }

    const onChange = (e) => {
        e.preventDefault();
        const field = props.field;
        if (!field.isReadOnly) {
            const value = e.target.value ? toUpperCase(e.target.value) : '';
            notValidateUpdateValue(props.formName, value, field, props.changeFormField).then(() => {
                if (props.onChangeHandler) {
                    props.onChangeHandler(value, field.name);
                }
            });
        }
    };

    return (
        <input
            id={props.id ? props.id : field.name}
            name={field.canonicalPath ? field.canonicalPath : field.name}
            maxLength={props.setMaxLength && field.maxLength ? field.maxLength : ''}
            value={props.customValue || field.value}
            type={field.type}
            readOnly={props.isReadOnly || field.isReadOnly || props.isNativeReadOnly}
            autoFocus={props.focus}
            onClick={props.onClick}
            onFocus={props.onFocus}
            onChange={props.upperCase ? onChange : props.onChange}
            onBlur={props.onBlur}
        />
    );
};

PromoInputText.propTypes = inputPropType([
    COUNTRY,
    'tel',
    'email',
    'number',
    'upload_doc',
    'password',
    'search',
    'digital',
    SBP_DROP_BOX,
    TEXT,
    'short_text',
    'url',
    DATE,
    'hidden',
    DROP_BOX,
    AUTOCOMPLETE_ADDRESS,
    AUTOCOMPLETE_POST_CODE,
    PHONE_COUNTRY,
]);

export default PromoInputBase(PromoInputText);
